/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Dutch (Netherlands)
export default {
  'ai-mate.chat-error-banner.description': 'Je chatgeschiedenis wordt maximaal 30 dagen opgeslagen.',
  'ai-mate.chat-error-banner.title': 'Start een nieuwe chat',
  'ai-mate.chat-error.description': 'Probeer <btn>de chat opnieuw te laden</btn>.',
  'ai-mate.chat-error.rate-limited-description':
    'Je hebt het maximumaantal aanvragen bereikt. Probeer het later opnieuw.',
  'ai-mate.chat-error.rate-limited-title': 'Te veel aanvragen',
  'ai-mate.chat-error.rovo-inactive-description':
    'Het lijkt erop dat Rovo niet is ingeschakeld op je site. <link>Rovo instellen</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo is inactief',
  'ai-mate.chat-error.title': 'We weten niet zeker wat er misging',
  'ai-mate.chat-input.file-close-icon-label': 'Bestand verwijderen',
  'ai-mate.chat-input.file-error-icon-label': 'Fout bij laden van bestand',
  'ai-mate.chat-view.chat-item.chat-delete-label': 'Verwijderen',
  'ai-mate.chat-view.chat-item.chat-options-for-conversation-button-label': 'Chatopties voor {conversationName}',
  'ai-mate.chat-view.chat-item.chat-rename-label': 'Naam wijzigen',
  'ai-mate.common.ui.expandable-section.collapse': 'Inklappen',
  'ai-mate.common.ui.expandable-section.expand': 'Uitvouwen',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.cancel-button-label.non-final': 'Annuleren',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.conversation-not-found-failure-message.non-final':
    'Het gesprek dat je probeert te verwijderen bestaat niet.',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-button-label.non-final':
    'Verwijderen',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-conversation-title.non-final':
    "Gesprek ''{name}' verwijderen?",
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.generic-failure-message.non-final':
    'Er is een fout opgetreden tijdens het verwijderen van dit gesprek. Probeer het opnieuw.',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.modal-body.non-final':
    'Weet je zeker dat je dit gesprek wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.cancel-button-label.non-final': 'Annuleren',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.channel-not-found-error-message.non-final':
    'Het kanaal dat je probeert te bewerken bestaat niet.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.edit-name-label.non-final': 'Naam',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.generic-error-message.non-final':
    'Er is een fout opgetreden tijdens het bewerken van dit gesprek. Probeer het opnieuw.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.modal-title.non-final': 'Gesprek bewerken',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.name-is-same-error-message.non-final':
    'De naam is hetzelfde als de huidige naam.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.save-button-label.non-final': 'Opslaan',
  'ai-mate.conversation-list-view.accessible-search-results':
    '{results, plural, one {{results,number} resultaat gevonden} other {{results,number} resultaten gevonden}}',
  'ai-mate.conversation-list-view.back-button.label': 'Terug',
  'ai-mate.conversation-list-view.close-chat-button.label': 'Chat sluiten',
  'ai-mate.conversation-list-view.header-title': 'Chatgeschiedenis',
  'ai-mate.conversation-list-view.new-chat-button.label': 'Nieuwe chat',
  'ai-mate.conversation-list-view.no-chat': 'Geen resultaten',
  'ai-mate.conversation-list-view.search-input.placeholder': 'Doorzoek chats',
  'ai-mate.expander.hide-details': 'Details verbergen',
  'ai-mate.expander.show-details': 'Meer details tonen',
  'ai-mate.main-chat.close-chat-panel-button-label': 'Chat sluiten',
  'ai-mate.main-chat.maximize-chat-button-label': 'Volledig scherm',
  'ai-mate.main-chat.minimize-chat-button-label': 'Weergave herstellen',
  'ai-mate.main-chat.new-chat-button-label': 'Nieuw',
  'ai-mate.main-chat.new-chat-button-label-full-screen': 'Nieuwe chat',
  'conversation-assistant-button.rovo-chat-label': 'Rovo-chat',
  'highlight-actions.rovo-chat-custom-prompt-submit-button.text': 'Verzenden',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Vraag AI hierover',
  'highlight-actions.rovo-chat-explain-option.text': 'Uitleggen',
  'highlight-actions.rovo-chat-explain-prompt':
    'Leg dit uit door het anders te formuleren en extra details toe te voegen, maar gebruik heel eenvoudige taal, korte zinnen en geef voorbeelden of definities van alle technische terminologie die in de oorspronkelijke formulering worden gebruikt.',
  'highlight-actions.rovo-chat-find-resources-option.text': 'Hulpmiddelen vinden',
  'highlight-actions.rovo-chat-find-resources-prompt':
    'Vind alleen middelen binnen de kennis van de organisatie die de afgelegde verklaringen ondersteunen.',
  'highlight-actions.rovo-chat-give-examples-option.text': 'Geef voorbeelden',
  'highlight-actions.rovo-chat-give-examples-prompt':
    'Geef voorbeelden hiervan op basis van organisatorische middelen of algemene kennis. Als er geen middelen zijn om te geven, probeer dan een metaforisch voorbeeld te geven waardoor iemand dit beter kan begrijpen.',
  'highlight-actions.rovo-chat-give-feedback-option.text': 'Feedback geven',
  'highlight-actions.rovo-chat-give-feedback-prompt':
    'Geef feedback door de formulering ervan te herzien. Geef commentaar over woordkeuze, grammatica en interpunctie. Wees positief en enthousiast, maar geef altijd minstens één ding om te verbeteren of te veranderen.',
  'highlight-actions.rovo-chat-more-options.tooltip': 'Aanbevelingen voor de chat',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'Chat openen',
  'highlight-actions.rovo-chat-summarize-option.text': 'Samenvatten',
  'highlight-actions.rovo-chat-summarize-prompt':
    'Benadruk de belangrijkste punten hiervan. Concentreer je op essentiële informatie en sluit onnodige details uit. Geef een beknopt overzicht in één alinea.',
  'highlight-actions.rovo-chat.button-text': 'Chat',
  'highlight-actions.rovo-chat.button-text-ask-in-chat': 'Vraag het in de chat',
  'highlight-actions.rovo-chat.placeholder-prompt': 'Stel hier een vraag over.',
  'horizontal-scroll-container.scroll-left': 'Scrol naar links',
  'horizontal-scroll-container.scroll-right': 'Scrol naar rechts',
  'rovo-chat.deep-research-spotlight.description':
    'Schakel Diepgaand onderzoek in en voer een prompt in. Rovo maakt een plan aan, voert het onderzoek uit en genereert een volledig rapport.',
  'rovo-chat.deep-research-spotlight.dismiss': 'Negeren',
  'rovo-chat.deep-research-spotlight.heading': 'Maak kennis met diepgaand onderzoek in Rovo',
  'rovo-chat.file-upload-dropzone.drag-drop-message': 'Sleep om context toe te voegen',
  'rovo-chat.message-file.icon-label': 'Bestand',
};
